import { render, staticRenderFns } from "./Animal.vue?vue&type=template&id=064b9b6f&scoped=true&"
import script from "./Animal.vue?vue&type=script&lang=js&"
export * from "./Animal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b9b6f",
  null
  
)

export default component.exports